var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"so-photo",attrs:{"src":'data:image/jpeg;base64,'+_vm.src,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }